import appReducers from '../reducer/app';
import salesReducers from "../reducer/sales";
import iamReducers from "../reducer/iam";
import contentReducers from "../reducer/content";
import qnrReducers from "../reducer/qnr";
import caseInfoReducers from "../reducer/caseInfo";
import screeningPrintReducers from "../reducer/screeningPrint";
import collectionDateReducers from "../reducer/collectionDate";
import testDateReducers from "../reducer/testDate";
import testPrintReducers from "../reducer/testPrint";
import updateLabNoReducers from "../reducer/updateLabNo";
import screeningResultsReducers from "../reducer/screeningResults";

const rootReducer = {
    ...appReducers,
    ...iamReducers,
    ...salesReducers,
    ...contentReducers,
    ...qnrReducers,
    ...caseInfoReducers,
    ...screeningPrintReducers,
    ...collectionDateReducers,
    ...testDateReducers,
    ...testPrintReducers,
    ...updateLabNoReducers,
    ...screeningResultsReducers
};

export default rootReducer;
